import { combineReducers, configureStore } from "@reduxjs/toolkit";

import errorValidation from "../shared/redux/slice";
import loginSlice from "../containers/login/redux/slice";
import addToIciSlice from "../containers/add-to-ici/redux/slice";
import attachFromIciSlice from "../containers/attach-from-ici/redux/slice";

const reducer = combineReducers({
  errorValidation: errorValidation.reducer,
  loginSlice,
  addToIciSlice,
  attachFromIciSlice,
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
